import request from '@/utils/request'
// 获取匹配信息
export function getPageList() {
  return request({
    url: '/page/mapList',
    method: 'get'
  })
}
// 获取首页page
export function getPage(data) {
  return request({
    url: '/page/list',
    method: 'post',
    data
  })
}
// 添加修改page
export function addPage(data) {
  return request({
    url: '/page/saveOrUpdate',
    method: 'post',
    data
  })
}
// 查看详情
export function pageDetail(id) {
  return request({
    url: `page/getByid/${id}`,
    method: 'get'
  })
}
// 删除page
export function deletePage(id) {
  return request({
    url: `/page/delPage/${id}`,
    method: 'get'
  })
}
// 修改发布状态
export function updateStatus(data) {
  return request({
    url: '/page/updateStatus',
    method: 'post',
    data
  })
}

// 桑基图数据
export function getSanKeyData(data) {
  return request({
    url: '/sankey/sankey',
    method: 'post',
    data
  })
}
